<template>
  <div>
    <p>
      You are logged out.
    </p>
  </div>
</template>